import { useTheme } from "@mui/material/styles";
import React from "react";

const ThemeVariables = () => {
  const theme = useTheme();

  // --action-hover-color: ${theme.palette.action.hover};
  const themeVariables = `
  :root {
    --action-active: ${theme.palette.action.active};
    --action-selected: ${theme.palette.action.selected};
      --success-main: ${theme.palette.success.main};
      --success-dark: ${theme.palette.success.dark};
      --success-contrast-text: ${theme.palette.success.contrastText};
      --warning-main: ${theme.palette.warning.main};
      --warning-dark: ${theme.palette.warning.dark};
      --warning-contrast-text: ${theme.palette.warning.contrastText};
      --error-main: ${theme.palette.error.main};
      --error-dark: ${theme.palette.error.dark};
      --error-contrast-text: ${theme.palette.error.contrastText};
      --info-main: ${theme.palette.info.main};
      --info-dark: ${theme.palette.info.dark};
      --info-light: ${theme.palette.info.light};
      --text-primary: ${theme.palette.text.primary};
      --text-disabled: ${theme.palette.text.disabled};
      --text-secondary: ${theme.palette.text.secondary};
      --font-family: ${theme.typography.fontFamily};

      --font-display-500: ${theme.typography.heading.h1}
      --font-display-400: ${theme.typography.heading.h2}
      --font-display-300: ${theme.typography.heading.h3}
      --font-display-200: ${theme.typography.heading.h4}
      --font-display-100: ${theme.typography.heading.h5}

      --font-interface-400-default: ${theme.typography.h1.default}
      --font-interface-400-regular: ${theme.typography.h1.regular}
      --font-interface-400-semi-bold: ${theme.typography.h1.semiBold}

      --font-interface-300-default: ${theme.typography.h2.default}
      --font-interface-300-regular: ${theme.typography.h2.regular}
      --font-interface-300-semi-bold: ${theme.typography.h2.semiBold}

      --font-interface-200-default: ${theme.typography.h3.default}
      --font-interface-200-regular: ${theme.typography.h3.regular}
      --font-interface-200-semi-bold: ${theme.typography.h3.semiBold}
      
      --font-interface-100-default: ${theme.typography.h4.default}
      --font-interface-100-regular: ${theme.typography.h4.regular}
      --font-interface-100-semi-bold: ${theme.typography.h4.semiBold}
    }
  `;

  return <style>{themeVariables}</style>;
};

export default ThemeVariables;
